module.exports = __webpack_public_path__ + "static/media/img1.5c7cb212.jpeg";